<template>
  <section class="ak--support">
    <div class="ak--support--wrapper">
      <v-container class="traffic-insurance">
        <h2 class="company-info--heading section-title-crosspage">
          Sağlık Sigortası
        </h2>
        <v-row class="mr-0 mt-14 align-center">
          <v-col cols="12" md="5" lg="5" xl="5" class="d-none d-md-flex">
            <v-img
              src="@/assets/illustrations/health-insurance-info.svg"
              class="traffic-insurance-image"
            ></v-img>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7">
            <h3 class="traffic-insurance__heading my-5">
              Sağlık Sigortası Nedir?
            </h3>
            <p>
              Sağlık Sigortası ile kendi sağlığınızı ve sevdiklerinizin
              sağlığını olası sağlık risklerine karşı güvence altına
              alabilirsiniz. Yaşanacak sağlık sorunlarından kaynaklanan sağlık
              giderlerine karşı sizleri koruma altına alan sigorta çeşidine
              <strong>sağlık sigortası</strong> denir.
            </p>
            <p>
              Sağlık sigortası, sigortalı bireyin tıbbi ve cerrahi masraflarının
              maliyetini karşılayan sigorta çeşididir.
            </p>
            <p>
              Hastalık ve kaza sonucunda yaşanabilecek sağlık sorunlarına karşı
              sağlık sigortası poliçesi sizlere teminatlar sunarak, sağlığınızı
              güvence altına almaktadır. Günlük hayatınızda yaşayacağınız sağlık
              sorunlarını sağlık sigortası ile güvence altına alabilirsiniz.
            </p>
            <p>
              Sağlık sigortası, hepimiz için en önemli olan sağlığımızı güvence
              altına almaktadır.
            </p>

            <div>
              <h3 class="traffic-insurance__heading">
                Sağlık Sigortası Çeşitleri Nelerdir?
              </h3>
              <p class="traffic-insurance__text">
                Sağlık sigortası, sağlık ihtiyaçlarına göre belirlenmektedir.
                Sağlık sigortası grubunda değerlendirilen planların kapsamı
                farklıdır.
              </p>
              <p class="traffic-insurance__text">
                Sağlık sigortaları kapsamında;
              </p>
              <ul>
                <li class="traffic-insurance__list-item">
                  Özel Sağlık Sigortası,
                </li>
                <li class="traffic-insurance__list-item">
                  Tamamlayıcı Sağlık Sigortası,
                </li>
                <li class="traffic-insurance__list-item">
                  Seyahat Sağlık Sigortası,
                </li>
                <li class="traffic-insurance__list-item">
                  Yabancı Uyruklu Sağlık Sigortası,
                </li>
                <li class="traffic-insurance__list-item">Doğum Sigortası</li>
              </ul>
              <p class="traffic-insurance__text">Yer almaktadır.</p>
              <p class="traffic-insurance__text">
                En uygun sağlık ihtiyaçlarını seçerek sağlığınızı güvence altına
                alabilirsiniz.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
